import { BaseEntity, getCachedSolarSystemEntity } from ".";
import { getCachedTypeEntity } from "./TypeEntityCache";

export class StationEntity extends BaseEntity {
  constructor(id: number, props: any) {
    super(id, props);
    this._dataTypeName = "Station";
  }

  async toJson(simple?: boolean): Promise<Excel.EntityCellValue> {
    const props: any = this.props;

    var entity = await super.toJson();
    // Properties
    if (entity.properties) {
      // - Solarsystem
      if (props.solarSystemID) {
        const solarSystemEntity = await getCachedSolarSystemEntity(props.solarSystemID);
        if (solarSystemEntity !== null) {
          if (simple !== true) entity.properties["solarsystem"] = await solarSystemEntity.toJson();
        }
      }
      // - Type
      if (props.typeID && simple !== true) {
        const typeEntity = await getCachedTypeEntity(props.typeID);
        if (typeEntity !== null) {
          entity.properties["type"] = await typeEntity.toJson();
          delete entity.properties["typeID"];
          // - Image
          if (entity.properties["type"].properties) {
            if (Object.prototype.hasOwnProperty.call(entity.properties["type"].properties, "image")) {
              entity.properties["image"] = entity.properties["type"].properties["image"];
            }
          }
        }
      }
      if (props.stationTypeID && simple !== true) {
        const typeEntity = await getCachedTypeEntity(props.stationTypeID);
        if (typeEntity !== null) {
          entity.properties["type"] = await typeEntity.toJson();
          delete entity.properties["stationTypeID"];
          // - Image
          if (entity.properties["type"].properties) {
            if (Object.prototype.hasOwnProperty.call(entity.properties["type"].properties, "image")) {
              entity.properties["image"] = entity.properties["type"].properties["image"];
            }
          }
        }
      } else {
        if (props.stationTypeID) {
          entity.properties["station_type_id"] = entity.properties["stationTypeID"];
          delete entity.properties["stationTypeID"];
        }
      }
    }
    // - Text
    entity.text = props.name;
    // Layouts
    entity.layouts = {
      card: {
        title: { property: "name" },
      },
    };
    // - Image
    if (
      entity.layouts &&
      entity.layouts.card &&
      entity.properties &&
      Object.prototype.hasOwnProperty.call(entity.properties, "image")
    ) {
      entity.layouts.card.mainImage = { property: "image" };
    }
    return entity;
  }
}
